/** Handles Firestore timestamps and serialized API timestamps. Missing dates are unknown. */
export function isJobUnavailable(
    job: { visibility?: string; finished?: boolean; endDate?: unknown },
    now = Date.now()
): boolean {
    if (job.visibility === 'private' || job.finished) return true
    if (job.endDate instanceof Date) return job.endDate.getTime() <= now
    if (typeof job.endDate === 'number') return Number.isFinite(job.endDate) && job.endDate <= now
    const value = job.endDate as { toMillis?: () => number; seconds?: number; _seconds?: number } | string | undefined
    const deadline =
        typeof value === 'string'
            ? Date.parse(value)
            : (value?.toMillis?.() ?? (value?.seconds ?? value?._seconds ?? NaN) * 1000)
    return Number.isFinite(deadline) && deadline <= now
}
